export enum EventNames {
    USER_GET_OTP = "User get otp clicked",
    USER_VERIFY_OTP_CLICKED = "User verify otp clicked",
    USER_CLICKED_PAY = "User clicked pay button",
    LANDING_PAGE_VIEW = "Landing page view",
    PAY_BY_WEB = "User clicked pay web",
    PAY_BY_APP = "User clicked pay app",
    GO_BACK = "User clicked go back",
    CLOSE_PAYMENT_MODAL = "User close payment modal"
}